import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const CodeIcon = (props)=>{
    const $ = c(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            d: "M10.6668 12L14.6668 8L10.6668 4M5.3335 4L1.3335 8L5.3335 12",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.height || $[2] !== props.width) {
        t1 = /*#__PURE__*/ jsx("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            children: t0
        });
        $[1] = props.height;
        $[2] = props.width;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
export { CodeIcon };
